import {analyticsLogEvent} from '../api'
import {EventNewsletterLabel, EventNewsletterAction, EventDetailsNewsletter} from '_types'

const eventName = 'newsletter'
const eventCategory = 'Newsletter'

interface Parameters {
    action: EventNewsletterAction
    label: EventNewsletterLabel
    preferences?: string
    userScore?: string
    hashId?: string
}

/**
 * Tracks a newsletter event triggered by the user.
 *
 * @param {Parameters} params - Object containing the event parameters.
 * @param {EventNewsletterAction} params.action - Action of the event.
 * @param {EventNewsletterLabel} params.label - Label of the event.
 * @param {string} [params.preferences] - Preferences of the event.
 * @param {string} [params.userScore] - User score of the event.
 * @param {string} [params.hashId] - Hashed customer email
 */
export function analyticsEventNewsletter({action, label, preferences, userScore, hashId}: Parameters): void {
    const eventDetails: EventDetailsNewsletter = {
        eventCategory: eventCategory,
        eventAction: action,
        eventLabel: label,
    }

    if (preferences) {
        eventDetails.interestList = preferences
    }

    if (userScore) {
        eventDetails.userScore = userScore
    }

    if (hashId) {
        eventDetails.hash_id = hashId
    }

    analyticsLogEvent(eventName, eventDetails)
}
